import React, { useState } from 'react';
import { Toolbar, Button, IconButton, Menu, Box } from '@mui/material';
import UserMenu from './UserMenu';
import Avatar from './Avatar';
import { StartProps } from '../Layouts/MainApp';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';
import MenuIcon from '@mui/icons-material/Menu';
import { SidebarMenuProps } from '../Layouts/Sidebar';

export const ToggleButton = (props: SidebarMenuProps) => {
  return <IconButton onClick={props.onToggle}>
    {props.open ? <MenuOpenIcon /> : <MenuIcon />}
  </IconButton>
}

const UserNav = (props: StartProps & SidebarMenuProps) => {

  const [showsUserMenu, showUserMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState();

  const toggleUserMenu = (event) => {
    showUserMenu(!showsUserMenu);
    setAnchorEl(event.currentTarget);
  }

  return (
    <Toolbar sx={{justifyContent: props.open ? "space-between" : "flex-start", gap: 2}}>
      <Button onClick={toggleUserMenu}
              size="small"
              startIcon={<Avatar size={32} user={props.user} color="primary" />}
              endIcon={props.open && <KeyboardArrowDownIcon color="secondary" sx={{display: {xs: 'none', lg: 'block'}}} />}
              disableRipple
              sx={{px: "0 !important"}}>
        <Box sx={{display: {xs: 'none', lg: 'block'}}}>{props.open && props.user?.display_name}</Box>
      </Button>
      <UserMenu {...props}
                anchorEl={anchorEl} 
                open={showsUserMenu}
                onClose={toggleUserMenu} />

      { props.open && <ToggleButton {...props} /> }
    </Toolbar>
  );
}

export default UserNav;